module.exports = __webpack_public_path__ + "static/media/logo_h_boxed.203fc729.svg";